var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popover',{ref:"helpPopover",attrs:{"showHeader":true,"headerTitle":_vm.title,"placement":_vm.placement}},[_c('div',{staticClass:"help-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }